import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { PublicOpportunityApi } from 'src/app/api/public-opportunity.api';
import { Message } from 'sustainment-component';
import { ConfirmationService } from 'primeng/api';
import {
  AppProjectAcceptDeclineRequest,
  VendorAPI
} from 'sustainment-component';

@Component({
  selector: 'app-dashboard-project-community-request',
  templateUrl: './project-community-request.component.html',
  styleUrls: ['./project-community-request.component.scss'],
  providers: [ConfirmationService],
  standalone: false
})
export class ProjectCommunityRequestComponent implements OnInit {
  public constructor(
    private _opportunityApi: PublicOpportunityApi,
    private _dialogService: DialogService,
    private vendorApi: VendorAPI
  ) {}

  @Input() public vendorName: string;
  @Input() public vendorLogo: string;
  @Input() public vendorSustainmentId: string;
  @Input() public opportunityId: string;
  @Input() public hasSupplierRecord: boolean;
  @Input() public isSupplierRecordArchived: boolean;
  @Input() public projectName: string;
  @Input() public opportunityRequestId: number;
  @Input() public messages: Message[];

  @Output() public invitationAccepted = new EventEmitter<void>();
  @Output() public companyClicked = new EventEmitter<void>();
  @Output() public invitationDenied = new EventEmitter<void>();

  public isAcceptingRequest = false;
  public isDecliningRequest = false;
  public requestMessage: string;

  public ngOnInit(): void {
    this.setRequestMessage();
  }

  private setRequestMessage(): void {
    if (!this.messages) return;

    this.requestMessage = this.messages.find(
      (e) => e.additionalFields && e.additionalFields.requestMessage
    )?.additionalFields?.requestMessage;
  }

  public companyClick(event: Event): void {
    event.stopPropagation();
    this.companyClicked.emit();
  }

  public declineProject(): void {
    const ref = this._dialogService.open(AppProjectAcceptDeclineRequest, {
      data: {
        requesterName: this.vendorName,
        requesterHasSupplierRecord: this.hasSupplierRecord,
        requesterHasSupplierRecordArchived: this.isSupplierRecordArchived,
        isDecliningRequest: true,
        projectName: this.projectName
      },
      showHeader: false
    });

    ref.onClose.subscribe((note: string) => {
      if (note) {
        this.isDecliningRequest = true;
        this._opportunityApi
          .declineRequest(this.opportunityId, this.opportunityRequestId, note)
          .subscribe(
            () => {
              this.invitationDenied.emit();
            },
            () => {
              this.isDecliningRequest = false;
            }
          );
      }
    });
  }

  public acceptProject(): void {
    const ref = this._dialogService.open(AppProjectAcceptDeclineRequest, {
      data: {
        requesterName: this.vendorName,
        requesterHasSupplierRecord: this.hasSupplierRecord,
        requesterHasSupplierRecordArchived: this.isSupplierRecordArchived,
        isDecliningRequest: false,
        projectName: this.projectName
      },
      showHeader: false
    });

    ref.onClose.subscribe((note: string) => {
      if (note) {
        this.isAcceptingRequest = true;
        this._opportunityApi
          .acceptRequest(this.opportunityId, this.opportunityRequestId, note)
          .subscribe(
            () => {
              if (!this.hasSupplierRecord && !this.isSupplierRecordArchived) {
                this.vendorApi
                  .createSupplierRecord(this.vendorSustainmentId)
                  .subscribe(() => this.invitationAccepted.emit());
              } else if (this.isSupplierRecordArchived) {
                this.vendorApi
                  .restoreSupplier(this.vendorSustainmentId)
                  .subscribe(() => this.invitationAccepted.emit());
              } else {
                this.invitationAccepted.emit();
              }
            },
            () => {
              this.isAcceptingRequest = false;
            }
          );
      }
    });
  }
}
